import { p as n, c as a } from "../../styled-components.browser.esm-DBaC0ZEI.mjs";
import { B as o } from "../../button-BIXC-Zd-.mjs";
const d = n(o)`
  &.ant-btn-primary {
    box-shadow: none !important;
  }

  &.ant-btn-text:not(:disabled):hover {
    background-color: transparent !important;
  }

  ${({
  actionButton: t
}) => t && a`
      svg {
        margin-right: var(--space-8);
      }
    `}

  ${({
  actionButton2: t
}) => t && a`
      svg {
        margin-right: var(--space-4);
      }
    `}

  ${({
  iconButton: t
}) => t === "without_bg" && a`
      border: 0 !important;
      box-shadow: none !important;
      background-color: transparent !important;

      &.ant-btn:hover {
        background: transparent !important;
      }
      &.ant-btn:focus {
        background: transparent !important;
      }
      &.ant-btn-default {
        box-shadow: none !important;
      }
    `}

  ${({
  iconButton: t
}) => t === "without_border" && a`
      border: 0;
      box-shadow: none;
    `}

  ${({
  iconButton: t
}) => t === "without_border_and_animation" && a`
      border: 0;
      box-shadow: none;

      &.ant-slide-up-appear,
      .ant-slide-up-enter,
      .ant-slide-up-leave {
        animation-duration: 0s !important;
      }
    `}

  ${({
  iconButton: t
}) => t === "default" && a`
      box-shadow: none;
    `}

  ${({
  theme: t
}) => t === "bordered" && a`
      background: transparent;
      color: var(--gray-1);

      &.ant-btn-default:not(:disabled):hover {
        color: var(--gray-1);
        background: transparent !important;
      }
    `}
`;
export {
  d as default
};
//# sourceMappingURL=style.js.map
